import type { TOC } from '@ember/component/template-only';
import type { Signature as ProviderSig } from 'parog-web/components/forc/provider';
import MrcDiagnosticFields from '../mrc/diagnostic-fields';

export default <template>
  <MrcDiagnosticFields @form={{@form}} />
</template> satisfies TOC<{
  Args: {
    form: ProviderSig['Blocks']['content'][0];
  };
}>;
